import React, { Fragment, useEffect } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import { Button } from 'reactstrap';
import EyeIcon from 'mdi-react/EyeIcon';
import { useSunrise25UsersUIContext } from '../Sunrise25UsersUIProvider';
import Sunrise25UserTableColumns, { Sunrise25UsersColumns } from './Sunrise25UsersTableColumns';
import { useDispatch, useSelector } from 'react-redux';
import { getSunrise25UsersList } from '../../redux/action';
import LoadingIcon from 'mdi-react/LoadingIcon';
import { defaultPaginationProps } from '@/shared/helpers';
import moment from 'moment';

const Sunrise25UsersTable = () => {
  const sunrise25UsersUIContext = useSunrise25UsersUIContext();
  const dispatch = useDispatch();
  const {
    data: sunrise25Users,
    error,
    filters,
    loading,
    totalRecords,
  } = useSelector((state) => state.campaignSunrise25User);
  const {
    pageSize: rowsPerPage,
    pageNumber: page,
    sortBy: orderBy,
    isSortOrderDescending,
  } = filters;

  useEffect(() => {
    dispatch(getSunrise25UsersList(filters));
  }, [filters]);

  const handleRequestSort = (event, property) => {};

  const handleChangePage = (event, currentPage) => {};

  const handleChangeRowsPerPage = (event) => {};

  const emptyRows =
    page === Math.ceil(totalRecords / rowsPerPage) ? rowsPerPage - sunrise25Users.length : 0;

  const renderActionButtons = ({ id: userId }) => (
    <div className="actions">
      <Button
        className="icon mb-0"
        color="success"
        outline
        onClick={() => sunrise25UsersUIContext.openViewUserDialog(userId)}
      >
        <p>
          <EyeIcon /> View
        </p>
      </Button>
    </div>
  );

  return (
    <Fragment>
      <div className="material-table__wrap">
        <Table className="material-table">
          <TableBody>
            <Sunrise25UserTableColumns
              order={isSortOrderDescending ? 'desc' : 'asc'}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={rowsPerPage}
            />
            {(loading || !!error) && (
              <TableRow>
                <TableCell colSpan={Sunrise25UsersColumns.length}>
                  {loading && (
                    <div className={'text-center overflow-hidden'}>
                      <div className="panel__refresh position-relative" style={{ height: 75 }}>
                        <LoadingIcon />
                      </div>
                    </div>
                  )}
                  <div className={'text-center'}>
                    <p className={!!error ? 'm-5' : ''}>{error || 'Loading Users...'}</p>
                  </div>
                </TableCell>
              </TableRow>
            )}
            {sunrise25Users.map((sunrise25User) => {
              return (
                <TableRow className="material-table" tabIndex={-1} key={sunrise25User.userId}>
                  <TableCell align="center" className="material-table__cell">
                    {sunrise25User?.firstName}
                  </TableCell>
                  <TableCell align="center" className="material-table__cell">
                    {sunrise25User?.lastName}
                  </TableCell>
                  <TableCell align="center" className="material-table__cell">
                    {moment(sunrise25User?.enrollmentDate).format('DD/MM/yyyy')}
                  </TableCell>
                  <TableCell align="center" className="material-table__cell">
                    {sunrise25User?.location}
                  </TableCell>
                  <TableCell align="center" className="material-table__cell">
                    {sunrise25User?.countryName}
                  </TableCell>

                  {/* <TableCell
                                            align="center"
                                            className="material-table__cell"
                                            style={{ minWidth: '295px' }}
                                        >
                                            {renderActionButtons(user)}
                                        </TableCell> */}
                </TableRow>
              );
            })}
            {emptyRows > 0 && (
              <TableRow style={{ height: 49 * emptyRows }}>
                <TableCell colSpan={Sunrise25UsersColumns.length} />
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
      {/* <TablePagination
        count={totalRecords}
        rowsPerPage={rowsPerPage}
        page={page - 1}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        component={defaultPaginationProps.component}
        backIconButtonProps={defaultPaginationProps.backIconButton}
        nextIconButtonProps={defaultPaginationProps.nextIconButton}
        rowsPerPageOptions={defaultPaginationProps.rowsPerPage}
        className={defaultPaginationProps.className}
        dir={defaultPaginationProps.dir}
      /> */}
    </Fragment>
  );
};

export default Sunrise25UsersTable;
